// Generic imports
import styled from "styled-components"

// Static imports

export const Styles = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  top: 65px;
  z-index: 1;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;

  .background {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  .success-modal {
    position: relative;
    background: white;
    box-shadow: 0px 20px 50px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    padding: 10px 30px;
    z-index: 2;
    min-width: 300px;
    max-width: 627px;
    max-height: 540px;
    text-align: center;
    overflow-x: auto;

    .title {
      margin-bottom: 20px;
      margin-top: 8px;
      font-size: 16px;
      font-weight: bold;
    }
  }

  .success-modal-img {
    width: 55%;
    margin: auto;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  button {
    padding-left: 50px;
    padding-right: 50px;
    margin-top: 20px;
    margin-bottom: 15px;
  }

  @media only screen and (max-width: 767.98px) {
    .success-modal {
      .title {
        margin-bottom: 10px;
        font-size: 14px;
      }
    }
  }
`
